module.exports = __webpack_public_path__ + "img/women's-room.347a9ac5.png";